import Head from "next/head";
import React from "react";

import TabsMenu from "components/global/TabsMenu/TabsMenu";
import Privacy from "components/privacy/Privacy/Privacy";
import CONSTANTS from "config/constants";

const { TITLE } = CONSTANTS;

interface Props {}

const PrivacyPage = (props: Props) => {
  return (
    <>
      <Head>
        <title>Políticas de privacidad | {TITLE}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <TabsMenu>
        <Privacy />
      </TabsMenu>
    </>
  );
};

export default PrivacyPage;
